"use strict";
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.filterPinoMessage = void 0;
var filterPinoMessage = function(pinoMessage) {
    var pid = pinoMessage.pid, hostname = pinoMessage.hostname, otherProperties = _object_without_properties(pinoMessage, [
        "pid",
        "hostname"
    ]);
    return otherProperties;
};
exports.filterPinoMessage = filterPinoMessage; //# sourceMappingURL=filterPinoMessage.js.map
